export const FormContentBlockerLayout = {
    labelCol: {
        span: 6
    },
    wrapperCol: {
        span: 16
    }
};
export * from "./fields";
export * from "./form";
